import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import {
  changeUserPassword,
  confirmChangePassword,
  confirmLogin,
  login,
  sendForgotPasswordOtp,
  getCurrentUserRoles,
  getCurrenUserInfo,
  getServerUrl,
  getCrawlServerUrl,
} from './securityActions';

const initialState = {
  uuid: '',
  isLoginOtp: true,
  isLoading: false,
  username: '',
  password: '',
  rememberMe: false,
  changePasswordToken: '',
  userStatus: [],
  isLoadingUserStatus: true,
  serverUrl: '',
  crawlServerUrl: '',
  currentUserInfo: {
    id: null,
    username: '',
    name: '',
    enabled: true,
    roleName: '',
    createdOn: '',
  },
};

const securitySlice = createSlice({
  name: 'security',
  initialState,
  reducers: {
    resetParams: (state) => {
      state.uuid = '';
      state.isLoading = false;
      state.username = '';
      state.changePasswordToken = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoginOtp = true;
        state.username = action.payload.username;
        state.password = action.payload.password;
        state.rememberMe = action.payload.rememberMe;
        state.uuid = action.payload.uuid;
      })
      .addCase(sendForgotPasswordOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoginOtp = false;
        state.username = action.payload.username;
        state.uuid = action.payload.uuid;
      })
      .addCase(confirmChangePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.changePasswordToken = action.payload?.changePasswordToken;
      })
      .addCase(getCurrenUserInfo.fulfilled, (state, action) => {
        state.currentUserInfo = action.payload;
      })
      .addCase(getCurrentUserRoles.fulfilled, (state, action) => {
        state.isLoadingUserStatus = false;
        state.userStatus = action.payload;
      })
      .addCase(getCurrentUserRoles.rejected, (state) => {
        state.isLoadingUserStatus = false;
      })
      .addCase(getCurrentUserRoles.pending, (state) => {
        state.isLoadingUserStatus = true;
      })

      .addCase(getServerUrl.fulfilled, (state, action) => {
        state.serverUrl = action.payload;
      })
      .addCase(getCrawlServerUrl.fulfilled, (state, action) => {
        state.crawlServerUrl = action.payload;
      })

      .addMatcher(
        isAnyOf(
          login.pending,
          confirmLogin.pending,
          sendForgotPasswordOtp.pending,
          confirmChangePassword.pending,
          changeUserPassword.pending,
        ),
        (state) => {
          state.isLoading = true;
        },
      )
      .addMatcher(
        isAnyOf(
          login.rejected,
          confirmLogin.rejected,
          confirmLogin.fulfilled,
          sendForgotPasswordOtp.rejected,
          confirmChangePassword.rejected,
          changeUserPassword.rejected,
          changeUserPassword.fulfilled,
        ),
        (state) => {
          state.isLoading = false;
        },
      );
  },
});

export const { resetParams } = securitySlice.actions;

export default securitySlice.reducer;
